import React, { useEffect, useState } from "react";
import { TobBar } from "./components/top-bar";
import { Box, CircularProgress } from "@mui/material";
import BookingForm from "./components/booking-form";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormFields, schema } from "./constants";
import KAFDImage from "src/assets/kafd.png";
import BookedSuccessfully from "./components/booked-successfully";
import KafdPaymentFailed from "./components/payment-failed";
import { useParams } from "react-router-dom";
import { useGetKAFDBooking } from "src/api/kafd-prebooking";

const KAFDPreBookingPage: React.FC = () => {
  let { id: bookingId } = useParams();
  const [bookingStatus, setBookingStatus] = useState<
    "init" | "paid" | "failedPayment"
  >("init");

  // APIS
  const {
    status,
    isFetching,
    data: bookingData,
  } = useGetKAFDBooking(bookingId as string);

  // React hook form
  const methods = useForm<FormFields>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {
      location: "",
    },
  });

  useEffect(() => {
    if (status === "success") {
      setBookingStatus("paid");
    } else if (status === "error") {
      setBookingStatus("failedPayment");
    }
  }, [status]);

  return (
    <Box
      display="flex"
      pb={6}
      justifyContent="center"
      position={"relative"}
      px={{ xs: 2, sm: 4 }}
    >
      <Box position={"absolute"} top={"0"} zIndex={0}>
        <img
          src={KAFDImage}
          // height={408}
          width={"100%"}
          // style={{ objectFit: "cover" }}
          alt=""
        />
      </Box>
      <Box width={"100%"} maxWidth={"1340px"} zIndex={3}>
        <TobBar />
        <Box>
          {!isFetching ? (
            <FormProvider {...methods}>
              {!bookingId ? (
                <BookingForm />
              ) : (
                <>
                  {bookingStatus === "failedPayment" ? (
                    <KafdPaymentFailed />
                  ) : (
                    <BookedSuccessfully bookingData={bookingData?.data} />
                  )}
                </>
              )}
            </FormProvider>
          ) : (
            <Box pt={"130px"} display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default KAFDPreBookingPage;
